import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { StageNav } from '@/components/generals/stage-nav'
import Amour from '@/components/sections/amour/Amour'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <main className='relative h-dvh w-full overflow-hidden bg-[#050506] text-[#F4F1EA]'>
                <Amour />

                {/* Laid over the section rather than added to it — the heart owns
                    its own chrome and stays untouched, and the overlay only takes
                    pointer events on the words themselves. */}
                <StageNav active='/' floating />
            </main>
        </>
    )
}

export default Home
